module.exports = __webpack_public_path__ + "static/02-3-d786f8d54c489eafff67add817ee08e3.jpg";